import React from 'react';
import { FiHeart } from 'react-icons/fi';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="logo">
              <span className="logo-icon">S</span>
              <span className="logo-text">Slink</span>
            </div>
            <p>Connect with real people, make genuine connections, and earn money through video calls.</p>
          </div>
          <div className="footer-links">
            <h4>Quick Links</h4>
            <a href="#home">Home</a>
            <a href="#features">Features</a>
            <a href="#earn">Earn Money</a>
            <a href="#about">About</a>
            <a href="#contact">Contact</a>
          </div>
          <div className="footer-links">
            <h4>Legal</h4>
            <a href="#privacy-policy">Privacy Policy</a>
            <a href="#terms">Terms & Conditions</a>
            <a href="#refund-policy">Refund Policy</a>
          </div>
          <div className="footer-links">
            <h4>Download</h4>
            <a href="https://slink.astergo.in/slink-dating-app.apk" className="footer-download">
              📱 Android (Download APK)
            </a>
            <span className="footer-coming">🍎 iOS - Coming Soon</span>
          </div>
        </div>
        <div className="footer-bottom">
          <p>© 2024 Slink. All rights reserved. Made with <FiHeart className="footer-heart" /> in India</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
